import { Card, CardBody, CardFooter, Col, Row, Table } from "react-bootstrap";
import { BsDeviceSsdFill } from "react-icons/bs";
import { FaFileSignature } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import CommonUtils from "../../../../utils/common";

const SummaryMask = ({ data, setStep, hwMode }) => {

    const UTILS = new CommonUtils();

    return (
        <>
            <Row>
                <Col xl="6">
                    <Card className="shadow-lg">
                        <CardBody>
                            <p className="text-energo text-start"><b><FaLocationDot /> Adresse</b></p>
                            <Table className="equalTable" responsive="sm">
                                <tbody>
                                    <tr>
                                        <td className="text-muted"><small>Anlagenverwendung</small></td>
                                        <td>{data.x_anlagenverwendung}</td>
                                    </tr>
                                    <tr hidden={hwMode && data.x_anlagenverwendung !== "Allgemeine Liegenschaftsteile"}>
                                        <td className="text-muted"><small>Speziefisch</small></td>
                                        <td>{data.x_anlagenverwendung_detail? data.x_anlagenverwendung_detail : "keine"}</td>
                                    </tr>
                                    <tr hidden={!hwMode}>
                                        <td className="text-muted"><small>Bestandseinheitennummer</small></td>
                                        <td>{data.bestand !== "" ? data.bestand : "keine"}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>Land</small></td>
                                        <td>{UTILS.country_id_toStringName(data.country_id)}</td>
                                    </tr>
                                    <tr hidden={data.country_id !== "12"}>
                                        <td className="text-muted"><small>Bundesland</small></td>
                                        <td>{UTILS.state_id_toStringName(data.state_id)}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>PLZ</small></td>
                                        <td>{data.zip}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>Ort</small></td>
                                        <td>{data.city}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>Straße</small></td>
                                        <td>{data.street}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>Hausnummer</small></td>
                                        <td>{data.houseNr}</td>
                                    </tr>
                                    <tr hidden={data.x_anlagenverwendung === "Allgemeine Liegenschaftsteile"}>
                                        <td className="text-muted"><small>Stiege</small></td>
                                        <td>{data.stiege}</td>
                                    </tr>
                                    <tr hidden={data.x_anlagenverwendung === "Allgemeine Liegenschaftsteile"}>
                                        <td className="text-muted"><small>Top</small></td>
                                        <td>{data.top}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </CardBody>
                        <CardFooter className="text-end">
                            <a 
                                onClick={e => {e.preventDefault(); setStep('address')}} 
                                href="ändern" 
                                className="link-energo"
                            >
                                Ändern
                            </a>
                        </CardFooter>
                    </Card>

                    <Card className="shadow-lg mt-3">
                        <CardBody style={data.register? {}: {opacity: 0.5}}>
                            <p className="text-energo"><b><FaFileSignature /> Anmeldedaten</b></p>
                            {data.register ?
                            <>
                                <Table className="equalTable" responsive="sm">
                                    <tbody>
                                        <tr>
                                            <td className="text-muted"><small>Anlage anmelden</small></td>
                                            <td>{UTILS.checkUncheckIcons(data.register)}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-muted"><small>Anmelden am</small></td>
                                            <td>{UTILS.dateToEuFormat(data.registerDate)}</td>
                                        </tr>
                                        {hwMode &&
                                            <>
                                                <tr>
                                                    <td className="text-muted"><small>Als Leerstand anmelden</small></td>
                                                    <td>{UTILS.checkUncheckIcons(data.leerstand)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted"><small>Abrechnung über Messtechnikunternehmen</small></td>
                                                    <td>{UTILS.checkUncheckIcons(data.useMtu)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted"><small>Name des Messtechnikunternehmens</small></td>
                                                    <td>{data.mtuName}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted"><small>Direktverrechnung</small></td>
                                                    <td>{UTILS.checkUncheckIcons(data.mtuDirect)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted"><small>Messtechnikunternehmen zahlt per Überweisung</small></td>
                                                    <td>{UTILS.checkUncheckIcons(data.mtuPaysOverTransfer)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted"><small>Kontoinhaber</small></td>
                                                    <td>{data.mtuAccountOwner}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted"><small>IBAN</small></td>
                                                    <td>{data.mtuIban}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted"><small>Kontaktperson</small></td>
                                                    <td>{data.contact.name}</td>
                                                </tr>
                                            </>
                                        }
                                    </tbody>
                                </Table>
                            </> :
                                <p className="text-center"><small>Anlage nur zum ENERGO hinzufügen.</small></p>
                            }
                        </CardBody>
                        <CardFooter className="text-end">
                            <a onClick={e => {e.preventDefault(); setStep("register")}} href="ändern" className="link-energo">Ändern</a>
                        </CardFooter>
                    </Card>
                </Col>
                <Col xs="12" md="6" xl="6">
                    <Card className="shadow-lg">
                        <CardBody>
                            <p className="text-energo"><b><BsDeviceSsdFill /> Anlagedaten</b></p>
                            <Table className="equalTable" responsive="sm">
                                <thead hidden={!data.secondZaehler || data.secondZaehler === false}>
                                    <tr>
                                        <td colSpan={2}>Zähler {data.x_zaehlernummer_01}</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="text-muted"><small>Zählerstandort</small></td>
                                        <td>{!data.zaehlerLocation || data.zaehlerLocation === ""? "Nicht bekannt": data.zaehlerLocation}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>Energieform</small></td>
                                        <td>{data.energyForm}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>Smartmeter</small></td>
                                        <td>
                                            {UTILS.checkUncheckIcons(data.x_is_smartmeter_01)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>Zählernummer</small></td>
                                        <td>{data.x_zaehlernummer_01}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>Zählpunktnummer</small></td>
                                        <td>{!data.x_zaehlpunktnummer_01 || data.x_zaehlpunktnummer_01 === ""? "Nicht vorhanden": data.x_zaehlpunktnummer_01}</td>
                                    </tr>
                                    <tr hidden={!data.zaehlerstand1 || data.zaehlerstand1 === ""}>
                                        <td className="text-muted"><small>Zählerstand</small></td>
                                        <td>{data.zaehlerstand1}</td>
                                    </tr>
                                </tbody>
                            </Table>
                            <Table hidden={!data.secondZaehler || data.secondZaehler === false} className="equalTable mt-4">
                                <thead>
                                    <tr>
                                        <td colSpan={2}>Zähler {data.x_zaehlernummer_02}</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="text-muted"><small>Zählerstandort</small></td>
                                        <td>{!data.zaehlerLocation || data.zaehlerLocation === ""? "Nicht bekannt": data.zaehlerLocation}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>Energieform</small></td>
                                        <td>{data.energyForm}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>Smartmeter</small></td>
                                        <td>
                                            {UTILS.checkUncheckIcons(data.x_is_smartmeter_01)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>Zählernummer</small></td>
                                        <td>{data.x_zaehlernummer_02}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>Zählpunktnummer</small></td>
                                        <td>{!data.x_zaehlpunktnummer_02 || data.x_zaehlpunktnummer_02 === ""? "Nicht vorhanden": data.x_zaehlpunktnummer_02}</td>
                                    </tr>
                                    <tr hidden={!data.zaehlerstand2 || data.zaehlerstand2 === ""}>
                                        <td className="text-muted"><small>Zählerstand</small></td>
                                        <td>{data.zaehlerstand2}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </CardBody>
                        <CardFooter className="text-end">
                            <a onClick={e => {e.preventDefault(); setStep("anlageData")}} href="ändern" className="link-energo">Ändern</a>
                        </CardFooter>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col xs="12" md="6" xl="6">
                    
                </Col>
            </Row>
        </>
    )
}
export default SummaryMask;